export default {
	title: "Soporte",
	newTicket: "Nuevo Ticket",
	ticketDetail: "Detalles del Ticket",
	subject: "Asunto",
	description: "Descripción",
	category: "Categoría",
	noTickets: "No se encontraron tickets",
	noTicketsDescription: "Aún no has abierto ningún ticket de soporte",
	comments: "Comentarios",
	replyPlaceholder: "Escribe tu respuesta...",
	send: "Enviar",
	createdAt: "Abierto el",
	updatedAt: "Actualizado el",
	backToList: "Volver a los tickets",
	totalTickets: "Total",
	openTickets: "Abiertos",
	attachImage: "Adjuntar imagen",
	categories: {
		BUG: "Bug",
		FEATURE: "Sugerencia",
		QUESTION: "Pregunta",
	},
	status: {
		OPEN: "Abierto",
		IN_PROGRESS: "En Progreso",
		RESOLVED: "Resuelto",
		CLOSED: "Cerrado",
	},
	messages: {
		ticketCreated: "Ticket creado con éxito",
		commentAdded: "Respuesta enviada con éxito",
		errorCreating: "Error al crear el ticket",
		errorLoading: "Error al cargar los tickets",
		errorAddingComment: "Error al enviar la respuesta",
		imageTooLarge: "Imagen demasiado grande. Tamaño máximo: 5MB",
	},
	table: {
		headers: {
			subject: "Asunto",
			category: "Categoría",
			status: "Estado",
			date: "Fecha",
			comments: "Respuestas",
		},
	},
};
